import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get as _get } from 'lodash';

import { Button, Card, CardBody, CardHeader, Col, Form, FormGroup, Label, Row } from 'reactstrap';
import { Field, Formik } from 'formik';

import ModalSuccess from '../../shared/modal/modal-success';
import PlainInput from '../../shared/inputs/plain';
import StyledDropzone from '../../shared/inputs/dropzone';

import validationSchema from './OfficerEdit.schema';

import { validate } from '../../../utils/form';
import { areaToSelectOptionsV2, districtToArea } from '../../../utils/formatters';

class OfficerEdit extends Component {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.object,
    }).isRequired,
    officer: PropTypes.shape().isRequired,
    isFetching: PropTypes.bool.isRequired,
    prevFieldsState: PropTypes.shape().isRequired,
    formStatus: PropTypes.shape().isRequired,

    districts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    towns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    areas: PropTypes.arrayOf(PropTypes.shape({})).isRequired,

    editOfficer: PropTypes.func.isRequired,
    removeOfficer: PropTypes.func.isRequired,
    removeOfficerPhoto: PropTypes.func.isRequired,
    saveFieldsState: PropTypes.func.isRequired,
    fetchDistricts: PropTypes.func.isRequired,
    fetchTowns: PropTypes.func.isRequired,
    fetchAreas: PropTypes.func.isRequired,
  };

  static defaultProps = {};

  state = {
    isOpenModalOfficer: false,
    isOpenModalPhoto: false,
  };

  componentDidMount() {
    const { districts, towns, areas, fetchDistricts, fetchTowns, fetchAreas } = this.props;

    if (!districts.length) fetchDistricts({ page: 1, limit: 1000 });
    if (!towns.length) fetchTowns({ page: 1, limit: 1000 });
    if (!areas.length) fetchAreas({ page: 1, limit: 1000 });
  }

  onSubmit = values => {
    const { saveFieldsState, editOfficer, match } = this.props;
    saveFieldsState(values);
    editOfficer({ id: match.params.id, data: values });
  };

  onRemoveOfficerAsk = () => {
    this.setState({
      isOpenModalOfficer: true,
    });
  };

  onModalOfficerClose = isOk => {
    this.setState({
      isOpenModalOfficer: false,
    });

    if (!isOk) return;

    const { removeOfficer, match } = this.props;
    removeOfficer({ id: match.params.id, response: this.onRemoveSuccess });
  };

  onRemoveSuccess = () => {
    const { history } = this.props;
    history.push(`/admin/officers`);
  };

  onRemovePhotoAsk = () => {
    this.setState({
      isOpenModalPhoto: true,
    });
  };

  onModalPhotoClose = isOk => {
    this.setState({
      isOpenModalPhoto: false,
    });

    if (!isOk) return;

    const { removeOfficerPhoto, match } = this.props;
    removeOfficerPhoto({ id: match.params.id });
  };

  render() {
    const { districts, towns, areas, officer, isFetching, prevFieldsState, formStatus } = this.props;
    const { isOpenModalOfficer, isOpenModalPhoto } = this.state;

    const areasO = areaToSelectOptionsV2(areas, towns, districts);
    const districtO = districtToArea(areas, towns);
    let idAddressArea = _get(officer, 'id_address_area', null);
    if (!idAddressArea) idAddressArea = _get(districtO, officer.id_district, -1);

    const initialValues = {
      area: _get(areasO, idAddressArea, ''),
      fio: officer.fio || '',
      podr: officer.podr || '',
      position: officer.position || '',
      place: officer.place || '',
      time: officer.time || '',
      tel: officer.tel || '',
      info: officer.info || '',
      func: officer.func || '',
      img: officer.img ? `/assets/officer/${officer.img}` : '/assets/user-male-icon.png',
      imgFile: null,
    };

    return (
      <div className="animated fadeIn">
        <ModalSuccess
          isOpen={isOpenModalOfficer}
          className="modal-warning"
          strHeader="Удаление руководителя"
          strBody="Вы уверены, что хотите удалить данного руководителя?"
          onClose={() => this.onModalOfficerClose(false)}
          onClickOk={() => this.onModalOfficerClose(true)}
          onClickCancel={() => this.onModalOfficerClose(false)}
        />
        <ModalSuccess
          isOpen={isOpenModalPhoto}
          className="modal-warning"
          strHeader="Удаление фото"
          strBody="Вы уверены, что хотите удалить данное фото?"
          onClose={() => this.onModalPhotoClose(false)}
          onClickOk={() => this.onModalPhotoClose(true)}
          onClickCancel={() => this.onModalPhotoClose(false)}
        />
        <Formik
          initialValues={initialValues}
          isInitialValid
          enableReinitialize
          validate={validate(validationSchema)}
          onSubmit={this.onSubmit}
          render={({
            values,
            // errors,
            // touched,
            setFieldValue,
            // handleChange,
            // handleBlur,
            handleSubmit,
            isValid,
          }) => (
            <Form onSubmit={handleSubmit} noValidate name="officerEditForm">
              <Row>
                <Col md={8}>
                  <Card>
                    <CardHeader>
                      <i className="icon-note" />
                      <strong>Руководитель</strong>
                      <Button color="primary" className="float-right" onClick={this.onRemoveOfficerAsk}>
                        Удалить руководителя
                      </Button>
                    </CardHeader>
                    <CardBody>
                      <FormGroup>
                        <Label htmlFor="officer-edit-area">Район</Label>
                        <Field component={PlainInput} id="officer-edit-area" name="area" value={values.area} disabled />
                      </FormGroup>

                      <FormGroup>
                        <Label htmlFor="officer-edit-fio">ФИО</Label>
                        <Field
                          component={PlainInput}
                          externalErrors={prevFieldsState.fio === values.fio ? formStatus.fio : ''}
                          id="officer-edit-fio"
                          name="fio"
                          value={values.fio}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label htmlFor="officer-edit-podr">Структурное подразделение</Label>
                        <Field
                          component={PlainInput}
                          externalErrors={prevFieldsState.podr === values.podr ? formStatus.podr : ''}
                          id="officer-edit-podr"
                          name="podr"
                          value={values.podr}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label htmlFor="officer-edit-position">Должность</Label>
                        <Field
                          component={PlainInput}
                          externalErrors={prevFieldsState.position === values.position ? formStatus.position : ''}
                          type="textarea"
                          rows="2"
                          id="officer-edit-position"
                          name="position"
                          value={values.position}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label htmlFor="officer-edit-place">Место приема</Label>
                        <Field
                          component={PlainInput}
                          externalErrors={prevFieldsState.place === values.place ? formStatus.place : ''}
                          id="officer-edit-place"
                          name="place"
                          value={values.place}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label htmlFor="officer-edit-time">День недели; время приема;</Label>
                        <Field
                          component={PlainInput}
                          externalErrors={prevFieldsState.time === values.time ? formStatus.time : ''}
                          id="officer-edit-time"
                          name="time"
                          value={values.time}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label htmlFor="officer-edit-tel">Телефон</Label>
                        <Field
                          component={PlainInput}
                          externalErrors={prevFieldsState.tel === values.tel ? formStatus.tel : ''}
                          id="officer-edit-tel"
                          name="tel"
                          value={values.tel}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label htmlFor="officer-edit-info">Дополнительная информация</Label>
                        <Field
                          component={PlainInput}
                          externalErrors={prevFieldsState.info === values.info ? formStatus.info : ''}
                          type="textarea"
                          rows="2"
                          id="officer-edit-info"
                          name="info"
                          value={values.info}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label htmlFor="officer-edit-func">Функции</Label>
                        <Field
                          component={PlainInput}
                          externalErrors={prevFieldsState.func === values.func ? formStatus.func : ''}
                          type="textarea"
                          rows="2"
                          id="officer-edit-func"
                          name="func"
                          value={values.func}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Button type="submit" color="primary" className="mr-1" disabled={isFetching || !isValid}>
                          {isFetching ? 'Сохранение...' : 'Сохранить'}
                        </Button>
                      </FormGroup>
                    </CardBody>
                  </Card>
                </Col>
                <Col md={4}>
                  <Card>
                    <CardHeader>
                      <i className="icon-note" />
                      <strong>Фото</strong>
                      <Button color="primary" className="float-right" onClick={this.onRemovePhotoAsk}>
                        Удалить фото
                      </Button>
                    </CardHeader>
                    <CardBody>
                      <FormGroup>
                        <Field
                          component={StyledDropzone}
                          id="officer-edit-img"
                          name="img"
                          onChange={acceptedFiles => {
                            if (acceptedFiles.length > 0) {
                              if (values.imgFile) URL.revokeObjectURL(values.img);

                              setFieldValue('img', URL.createObjectURL(acceptedFiles[0]));
                              setFieldValue('imgFile', acceptedFiles[0]);
                            }
                          }}
                          classNameType="personal"
                          text1="Кликните или перетащите сюда фотографию"
                          text2="По возможности сделайте предобработку фотографии. Если Вы отправите большое фото, то это может затормозить загрузки у пользователя"
                        />
                      </FormGroup>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Form>
          )}
        />
      </div>
    );
  }
}

export default OfficerEdit;
